import React from 'react'
import FormEnteVsJefe from '../view/RegistrarEnteVsJefe'
import ListaEnteVsJefe from '../view/ListarEnteVsJefe'

const AsociarEnteVsJefe = () => {
  return (
    <div>
        <FormEnteVsJefe/>
        <ListaEnteVsJefe/>
    </div>
  )
}

export default AsociarEnteVsJefe